<div class="container-fluid">
   <div class="row">
      <div class="col">
         <div class="delivery">
            <div class="col-md-12 d-flex justify-content-center flex-column">
               <div class="col-md-10 align-self-center mr-3">
                  <app-navigation-list [navigationList]="navList"></app-navigation-list>
               </div>
               <div class="delivery-items d-flex col-md-10 flex-column justify-content-between align-self-center">
                  <div class="delivery-items__container col-md-12">
                     <ng-container *ngFor="let service of serviceData; let i = index">
                        <div (click)="activateItem(service, i)" [ngClass]="{'active-item': arr[i]}"
                           class="delivery-items__container--item col-md-3">
                           <span>{{ service.name | titlecase | truncate: [29] }}</span>
                        </div>
                     </ng-container>
                  </div>
                  <div class="delivery-items__container--ins d-flex justify-content-center"
                     [ngClass]="{margin: serviceData}">
                     <span>
                        {{'public.add-delivery.instructions' | translate}}
                     </span>
                  </div>

                  <div *ngIf="code" class="delivery-items__search mr-auto ml-auto">
                     <span class="delivery-items__search--text mr-4">{{ 'public.add-delivery.orderNr' | translate
                        }}</span>
                     <input type="text" #input (input)="inputValue(input.value)" placeholder="Ex: 0000-00000-0000" />
                     <button class="btn btn-outline-info btn-sm ml-3" (click)="submit()" [disabled]="!orderId">
                        <i class="bi bi-arrow-left mr-1 mb-1"></i>{{ 'admin.search-sp' | translate }}
                     </button>
                  </div>
                  <div class="mt-4 col-12" style="position: relative">
                     <p class="progress-bar-custom" *ngIf="loading" style="max-width: 298px">
                        <ngb-progressbar id="bar" type="info" textType="white" [value]="valueBar" [showValue]="false"
                           [animated]="true"></ngb-progressbar>
                        <span *ngIf="valueChecking" class="checkbox-custom">
                           <input id="checkbox-2" class="checkbox-custom" name="checkbox-2" type="checkbox"
                              [checked]="true" />
                           <label for="checkbox-2" class="checkbox-custom-label"></label>
                        </span>
                     </p>
                     <div class="d-flex justify-content-center mt-3 flex-column align-items-center"
                        [ngClass]="{'error-message': !serviceData}">
                        <div class="optional d-flex flex-column mt-5">
                           <div class="optional-y d-flex align-items-center">
                              <span class="optional-text" *ngIf="order && order?.ticket.status">
                                 <span class="optional-text__succes col-md-3 mr-xl-3 mr-0">
                                    <span class="mr-xl-5 mr-1">
                                       <svg width="23" height="23" viewBox="0 0 18 18" fill="none"
                                          xmlns="http://www.w3.org/2000/svg">
                                          <path fill-rule="evenodd" clip-rule="evenodd"
                                             d="M8.8 17.6C11.1339 17.6 13.3722 16.6729 15.0225 15.0225C16.6729 13.3722 17.6 11.1339 17.6 8.8C17.6 6.46609 16.6729 4.22778 15.0225 2.57746C13.3722 0.92714 11.1339 0 8.8 0C6.46609 0 4.22778 0.92714 2.57746 2.57746C0.92714 4.22778 0 6.46609 0 8.8C0 11.1339 0.92714 13.3722 2.57746 15.0225C4.22778 16.6729 6.46609 17.6 8.8 17.6ZM12.8777 7.3777C13.0781 7.17024 13.1889 6.89237 13.1864 6.60396C13.1839 6.31554 13.0682 6.03965 12.8643 5.8357C12.6604 5.63175 12.3845 5.51606 12.096 5.51356C11.8076 5.51105 11.5298 5.62193 11.3223 5.8223L7.7 9.4446L6.2777 8.0223C6.07024 7.82193 5.79237 7.71105 5.50396 7.71356C5.21554 7.71606 4.93965 7.83175 4.7357 8.0357C4.53175 8.23965 4.41606 8.51554 4.41356 8.80396C4.41105 9.09237 4.52193 9.37024 4.7223 9.5777L6.9223 11.7777C7.12858 11.9839 7.40832 12.0998 7.7 12.0998C7.99168 12.0998 8.27142 11.9839 8.4777 11.7777L12.8777 7.3777Z"
                                             fill="#7DBCAA" />
                                       </svg>
                                    </span>
                                    <span>{{'public.add-delivery.orderNr' | translate}}</span> {{ orderId }}
                                    {{'public.add-delivery.found' | translate }}</span>
                              </span>
                              <span class="optional-text__name col-md-3"
                                 *ngIf="order && order?.ticket.status"><span>{{'public.add-delivery.service' |
                                    translate}}:</span>{{' ' + name }}</span>

                              <button *ngIf="order && order?.ticket.status" type="submit"
                                 class="btn btn-outline-info btn btn-sm ml-xl-5 ml-0" (click)="delivery()"
                                 [disabled]="order && order?.ticket.status !== 3 || idnpChecking !== idnpTicketCheck">
                                 <span><i class="bi bi-plus-circle mr-1"></i></span>
                                 {{ 'public.add-delivery.order-delivery' | translate }}
                              </button>
                           </div>
                     
                           <div class="align-self-start mt-3">

                              <div *ngIf="showNotCoincidingMessage" class="d-flex justify-content-start align-content-center command">
                                 <div *ngIf="!valueChecking">
                                     <ng-container *ngIf="idnpChecking !== idnpTicketCheck">
                                         <span class="text-danger ml-xl-5 text-left">{{'public.add-delivery.orderIDNPnomatch' | translate}}</span>
                                     </ng-container>
                                 </div>
                              </div>
                              <div *ngIf="errMessage" class="d-flex justify-content-start align-content-center command">
                                 <span class="attention-delivery">
                                    <i class="bi bi-exclamation-circle"></i></span>
                                 <span class="command-not text-left">
                                    {{'public.add-delivery.orderNr' | translate}} {{ orderId }} {{
                                    'public.add-delivery.not-found' | translate }}
                                 </span>
                              </div>
                              <span *ngIf="err" class="text-notdelivery">
                                 <span *ngIf="order && order?.ticket.status !== 3"
                                    class="tex text-danger ml-xl-5 ml-0">{{'public.add-delivery.order-notDelivery' |
                                    translate}}</span>
                              </span>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>

   <!--<ng-container *ngFor="let service of serviceData">-->
   <!--  <div>-->
   <!--    {{service.name}}-->
   <!--  </div>-->
   <!--</ng-container>-->                     